<ngx-skeleton-loader [theme]="{height: '22px', width: '50%'}"></ngx-skeleton-loader>
<ngx-skeleton-loader [theme]="{height: '1px', width: '100%', margin: '12px 0'}"></ngx-skeleton-loader>

<ngx-skeleton-loader [theme]="{height: '22px', width: '10%', margin: '4px 1% 4px 0%'}"></ngx-skeleton-loader>
<ngx-skeleton-loader [theme]="{height: '2px', width: '31%', margin: '12px 1%'}"></ngx-skeleton-loader>
<ngx-skeleton-loader [theme]="{height: '22px', width: '10%', margin: '4px 1%'}"></ngx-skeleton-loader>
<ngx-skeleton-loader [theme]="{height: '2px', width: '31%', margin: '12px 1%'}"></ngx-skeleton-loader>
<ngx-skeleton-loader [theme]="{height: '22px', width: '10%', margin: '4px 0% 4px 1%'}"></ngx-skeleton-loader>

<ngx-skeleton-loader [theme]="{height: '16px', width: '31%', margin: '6px 0'}"></ngx-skeleton-loader>
<ngx-skeleton-loader [theme]="{height: '16px', width: '72%', margin: '6px 0 14px 0'}"></ngx-skeleton-loader>
<ngx-skeleton-loader [theme]="{height: '100px', width: '100%', margin: '6px 0'}"></ngx-skeleton-loader>

